import { gql, useQuery } from "@apollo/client";
import type {
    ShowTranslationCalloutQueryVariables,
    ShowTranslationCalloutQuery,
} from "./__generated__/useShowTranslationCalloutQuery";

export const SHOW_TRANSLATION_CALLOUT_QUERY = gql`
    query ShowTranslationCalloutQuery($userPublicId: String, $linkHash: String) {
        customer(userPublicId: $userPublicId, linkHash: $linkHash) {
            publicId
            userData(userPublicId: $userPublicId) {
                showTranslationCallout
            }
        }
    }
`;

type Props = {
    variables: ShowTranslationCalloutQueryVariables;
};

export function useShowTranslationCalloutQuery({ variables }: Props) {
    return useQuery<ShowTranslationCalloutQuery, ShowTranslationCalloutQueryVariables>(
        SHOW_TRANSLATION_CALLOUT_QUERY,
        {
            variables,
            fetchPolicy: "no-cache",
            notifyOnNetworkStatusChange: true,
        },
    );
}
